import { render } from "./SupportTicketChat.vue?vue&type=template&id=e2b73a86&scoped=true"
import script from "./SupportTicketChat.vue?vue&type=script&lang=js"
export * from "./SupportTicketChat.vue?vue&type=script&lang=js"

import "./SupportTicketChat.vue?vue&type=style&index=0&id=e2b73a86&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e2b73a86"]])

export default __exports__